import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import { useDownloadEvents } from '@gov-nx/core/events';
import type { Nullable } from '@gov-nx/core/types';
import type { PageCode } from '@gov-nx/module/page';
import type { ePetitionAttachmentContextType } from './context.types';

export const ePetitionAttachmentContext =
	createContext<Nullable<ePetitionAttachmentContextType>>(null);

interface ePetitionAttachmentProviderProps {
	code: PageCode;
	children: ReactNode;
}

export function EPetitionAttachmentProvider({
	children,
}: ePetitionAttachmentProviderProps) {
	const { downloadEPetitionAttachment } = useDownloadEvents();

	return (
		<ePetitionAttachmentContext.Provider
			value={{
				downloadAttachment: (attachmentData, onSuccess) =>
					downloadEPetitionAttachment({
						attachmentData,
						callback: onSuccess,
					}),
			}}>
			{children}
		</ePetitionAttachmentContext.Provider>
	);
}

export const usePetitionAttachmentContext =
	(): ePetitionAttachmentContextType =>
		useContext(ePetitionAttachmentContext) as ePetitionAttachmentContextType;
